import React, { Component, createRef } from "react";
import InventoryServices from "../../services/axioServices/apiServices/InventoryServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import moment from "moment";
import * as XLSX from 'xlsx';
import { FinancealYearStartDateEndDate } from "../../utils/FinancialYearStartDateEndDate.js";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";
import { printFunction } from "../../components/print/printTemplate.js";

class PurchaseOrderRegister extends Component {
  constructor(props) {
    super(props);
    this.printRef = createRef();
    this.inventoryServices = new InventoryServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      companyName: '',
      partyDropdownList: [],
      rawMaterialList: [],
      packingMaterialDropDownList: [],
      totalCount: 0,
      tableStatus: "",
      filterDetails: {
        startDate: '',
        endDate: '',
        materialType: 'Both',
        partyId: '',
        packageMaterialId: '',
        rawMaterialId: '',
      },
      isPendingPurchseReport: false,
      purchaseOrderRegisterList: [],
      typeList: [
        { material: 'Both' },
        { material: 'Raw Material' },
        { material: 'Packing Material' },
      ],
      validationRules: {
        startDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "start date"
            ),
          },
        ],
        endDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "end date"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    }
  }

  componentDidMount() {
    let dates = FinancealYearStartDateEndDate()
    let filterDetails = this.state.filterDetails
    filterDetails.startDate = dates.startDate
    filterDetails.endDate = dates.endDate
    this.setState({ filterDetails: filterDetails })
    this.getAllPartyDropdown()
    const company = getAuthProps()
    this.setState({ companyName: company?.companyName })
  }

  getAllPartyDropdown = () => {
    this.commonServices.getAllPartyDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.partyName,
          value: item._id,
          email: item.email
        }));
        this.setState({ partyDropdownList: dropdownItems }, () => {
          this.getAllRMDropdown()
        });
      } else {
        this.getAllRMDropdown()
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllRMDropdown = () => {
    this.commonServices.getAllRMDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.rmName,
          value: item._id,
          uom: item.rmUOM
        }));
        this.setState({ rawMaterialList: dropdownItems }, () => {
          this.getAllPackingMaterialDropdown()
        });
      } else {
        this.getAllPackingMaterialDropdown()
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllPackingMaterialDropdown = () => {
    this.commonServices.getAllPackingMaterialDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.pmName,
          value: item._id,
          uom: item.pmUOM
        }));
        this.setState({ packingMaterialDropDownList: dropdownItems });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  resetForm = () => {
    let validState = this.state.validState
    validState.isValid = true
    validState.error = {}

    let filterDetails = this.state.filterDetails
    filterDetails.startDate = ""
    filterDetails.endDate = ""
    filterDetails.materialType = ""
    filterDetails.partyId = ""
    filterDetails.packageMaterialId = ""
    filterDetails.rawMaterialId = ""

    this.setState({ filterDetails: filterDetails, validState: validState, totalCount: 0, purchaseOrderRegisterList: [], tableStatus: "" });
  }

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.filterDetails
    details[name] = value;
    this.setState({ filterDetails: details })
  };

  handleDropdownChange = (e, name) => {
    const value = e.target.value;
    let details = this.state.filterDetails;
    details[name] = value;
    this.setState({ filterDetails: details });
  };

  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.filterDetails
    details[drpIdentity] = selected.value
    this.setState({ filterDetails: details });
  };

  getAllPurchaseOrderRegister = () => {
    let isAllFieldsValidate = this.isAllFieldsValidate()
    if (isAllFieldsValidate) {
      this.setState({ tableStatus: "Loading..." })
      let request = this.state.filterDetails
      this.inventoryServices.getAllPurchaseOrderRegister(request).then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          if (response.responseData.length === 0) {
            this.setState({ tableStatus: "No Record Found" })
          } else {
            this.setState({ tableStatus: "" })
          }
          let totalCount = response.responseData.length
          if (totalCount === 0) {
            this.setState({ noItemFound: "No Item Found" })

          }
          this.setState({ purchaseOrderRegisterList: response.responseData, totalCount: totalCount })
        } else {
          this.setState({ tableStatus: "" })
          this.SwalServices.Error(response.Message);
        }
      })
    }
  }

  isAllFieldsValidate = () => {
    const newValidState = isValidForm(
      this.state.filterDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid
  }

  render() {
    return (
      <div className="purchaseOrderRegister-page reports-page">
        <div className="item-search !mb-[10px]">
          <div className="item-grp">
            <div className="item-inner-grp flex gap-2.5 mb-3">
              <div className="start-date" style={{ width: "100%" }}>
                <label>Start Date</label>
                <input
                  className={` inputFocus ${this.state.validState?.error?.startDate ? "errorInput" : ""}`}
                  type="date"
                  id="startDate"
                  name="startDate"
                  autoComplete="off"
                  value={this.state.filterDetails.startDate}
                  onChange={(event) =>
                    this.handleChange(event, "startDate")
                  }
                  style={{ width: "100%" }}
                />
                {/* <ValidationText
                  error={this.state.validState.error.startDate}
                /> */}
              </div>
              <div className="end-date" style={{ width: "100%" }}>
                <label>End Date</label>
                <input
                  className={` inputFocus ${this.state.validState?.error?.endDate ? "errorInput" : ""}`}
                  type="date"
                  id="endDate"
                  name="endDate"
                  autoComplete="off"
                  value={this.state.filterDetails.endDate}
                  onChange={(event) =>
                    this.handleChange(event, "endDate")
                  }
                  style={{ width: "100%" }}
                />
                {/* <ValidationText
                  error={this.state.validState.error.endDate}
                /> */}
              </div>
              <div className="material-selector" style={{ width: "100%" }}>
                <label>Material Type</label>
                <select
                  value={this.state.filterDetails.materialType}
                  onChange={(e) =>
                    this.handleDropdownChange(e, "materialType", "FilterDetails")
                  }
                >
                  {this.state.typeList.map((x, key) => (
                    <option key={key} value={x.material}>
                      {x.material}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="dropdown-grp flex gap-2.5 mb-3.5">
              <div className="party-dropdown w-full">
                <label>Party Name</label>
                <MultiSelectDropdown
                  drpIdentity="partyId"
                  options={this.state.partyDropdownList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={(selected) => this.setFilterParameters(selected, 'partyId')}
                  allowSelectAll={false}
                  value={this.state.partyDropdownList.filter(
                    (party) =>
                      party.value === this.state.filterDetails.partyId
                  )}
                />
              </div>
              <div className="material-dropdown w-full" >
                <label>Material</label>
                {this.state.filterDetails.materialType === 'Raw Material' ?
                  <>
                    <MultiSelectDropdown
                      drpIdentity="rawMaterialId"
                      options={this.state.rawMaterialList}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      onChange={(selected) =>
                        this.setFilterParameters(selected, "rawMaterialId")
                      }
                      allowSelectAll={false}
                      value={this.state.rawMaterialList.find(
                        (party) =>
                          party.value === this.state.filterDetails.rawMaterialId
                      )}
                    />
                  </>
                  : this.state.filterDetails.materialType === 'Packing Material' ?
                    <>
                      <MultiSelectDropdown
                        drpIdentity="packageMaterialId"
                        options={this.state.packingMaterialDropDownList}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={(selected) =>
                          this.setFilterParameters(selected, "packageMaterialId")
                        }
                        allowSelectAll={false}
                        value={this.state.packingMaterialDropDownList.find(
                          (party) =>
                            party.value === this.state.filterDetails.packageMaterialId
                        )}
                      />
                    </>
                    :
                    <MultiSelectDropdown
                      drpIdentity="packageMaterialId"
                      options={this.state.packingMaterialDropDownList}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      onChange={(selected) =>
                        this.setFilterParameters(selected, "packageMaterialId")
                      }
                      allowSelectAll={false}
                      value={this.state.packingMaterialDropDownList.find(
                        (party) =>
                          party.value === this.state.filterDetails.packageMaterialId
                      )}
                      isDisabled={true}
                    />
                }
              </div>

            </div>
            <div className="btn-grp ">
              <button class="add-btn" onClick={() => this.getAllPurchaseOrderRegister()}>Search</button>
              <button class="cancel-btn" onClick={() => this.resetForm()}>Cancel</button>
              {this.state.totalCount > 0 ?
                <button class="print-btn" onClick={() => printFunction()}>Print</button>
                : null}
            </div>
          </div>
        </div>
        <div>
          <p className="mb-[3px] text-[15px] font-medium text-[#474747]">Total Count :- {this.state.totalCount ? this.state.totalCount : 0}</p>
        </div>
        <div class="item-listing">
          <div className="hidden print-title">
            <h4>Purchase Order Register Report</h4>
            <p><span>Material type:- {this.state.filterDetails.materialType}</span></p>
          </div>
          <div class="itemList-table">
            <div class="table-container" style={{ height: "calc(100vh - 280px)" }}>
              <table class="itemList">
                <thead>
                  <tr>
                    <td style={{ width: "5%" }} className="w-[5%]">PO. No</td>
                    <td style={{ width: "8%" }} className="w-[8%]">PO. Date</td>
                    <td style={{ width: "13%" }} className="w-[13%] no-print">Party Name</td>
                    <td style={{ width: "25%" }} className="w-[25%]">Item Name</td>
                    <td style={{ width: "5%" }} className="w-[5%]">Qty</td>
                    <td style={{ width: "5%" }} className="w-[5%]">Rate</td>
                    <td style={{ width: "5%" }} className="w-[5%]">Amount</td>
                    <td style={{ width: "7%" }} className="w-[7%]">GST</td>
                    <td style={{ width: "10%" }} className="w-[10%]">Status</td>
                    <td style={{ width: "8%" }} className="w-[8%] no-print">Material Type</td>
                  </tr>
                </thead>

                <tbody>
                  {this.state.purchaseOrderRegisterList && this.state.purchaseOrderRegisterList.length > 0 ?
                    this.state.purchaseOrderRegisterList.map((details, key) => (
                      <tr key={key}>
                        <td>{details.purchaseOrderId ? details.purchaseOrderId.purchaseOrderNo : ''}</td>
                        <td>{details.purchaseOrderId ? moment(details.purchaseOrderId.purchaseOrderDate).format('DD MMM yyyy') : ''}</td>
                        <td className="no-print">{details.purchaseOrderId ? details.purchaseOrderId.partyId.partyName : ''}</td>
                        <td>{details.rawMaterialId ? details.rawMaterialId.rmName : details.packageMaterialId.pmName}</td>
                        <td>{details.qty ? details.qty.toFixed(2) : 0.00}</td>
                        <td>{details.rate ? details.rate.toFixed(2) : 0.00}</td>
                        <td>{details.amount ? details.amount.toFixed(2) : 0.00}</td>
                        <td>{details.purchaseOrderId ? details.purchaseOrderId.gstApplicable : ''}</td>
                        <td>{details.purchaseOrderId ? details.purchaseOrderId.status : ''}</td>
                        <td className="no-print">{details.rawMaterialId ? 'Raw' : 'Package'}</td>
                      </tr>

                    )) : this.state.purchaseOrderRegisterList &&
                      this.state.purchaseOrderRegisterList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={10} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.purchaseOrderRegisterList &&
                      this.state.purchaseOrderRegisterList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/*----- Print layout -----*/}
        <div className='table-print mt-5 hidden' id="printableArea">
          {/* Header */}
          <div className="print-header">
            <table className="hdr-table">
              <tbody>
                <tr>
                  <td>
                    <div className="co-name">{this.state.companyName}</div>
                    <div className="rpt-sub">Purchase Order Register</div>
                  </td>
                  <td>
                    <div className="hdr-meta">
                      Material Type: <strong>{this.state.filterDetails.materialType}</strong>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="rule-thick" />
            <div className="rule-thin" />
          </div>


          <div className="print-content">

            {/* <div className="info-row">
                                                              <div>
                                                                <span className="info-label">Item Name:</span>
                                                                <p className="info-value">Paracetamol</p>
                                                              </div>
                                                            </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "25%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "15%" }} />
              </colgroup>

              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    PO. No
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    PO. Date
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Item Name
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Quantity
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Rate
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Amount
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    GST
                  </th>
                  <th style={{ textAlign: 'Left' }}>
                    Status
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.purchaseOrderRegisterList && this.state.purchaseOrderRegisterList.length > 0 ?
                  this.state.purchaseOrderRegisterList.map((details, key) => (
                    <tr key={key}>
                      <td style={{ textAlign: 'left' }}>
                        {details.purchaseOrderId ? details.purchaseOrderId.purchaseOrderNo : ''}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {details.purchaseOrderId ? moment(details.purchaseOrderId.purchaseOrderDate).format('DD MMM yyyy') : ''}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {details.rawMaterialId ? details.rawMaterialId.rmName : details.packageMaterialId.pmName}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.qty ? details.qty.toFixed(2) : 0.00}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.rate ? details.rate.toFixed(2) : 0.00}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.amount ? details.amount.toFixed(2) : 0.00}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.purchaseOrderId ? details.purchaseOrderId.gstApplicable : ''}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {details.purchaseOrderId ? details.purchaseOrderId.status : ''}
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="8" style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="print-footer">
            <div className="rule-foot">
              <table className="foot-tbl">
                <tbody>
                  <tr>
                    <td>* System generated report. No signature required.</td>
                    <td style={{ textAlign: "right" }}>
                      Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    );
  }
}
export default PurchaseOrderRegister;
